import {createAction, createReducer} from '@reduxjs/toolkit';
import {get} from 'lodash-es';

const MODULE_PREFIX = '[ SCRIP DETAILS LOOK UP DATA ]';

const Actions = {
	setScripDetailsLookUpData: `${MODULE_PREFIX} setScripDetailsLookUpData`,
};

// actions
export const setScripDetailsLookUpData = createAction(
	Actions.setScripDetailsLookUpData,
);

export const getScripDetailsLookUpData = (state = {}) => {
	const screenDetailsScreenIdData = get(state, 'scripDetailsLookUpData', {});
	return screenDetailsScreenIdData;
};

export const getScripDetailsScreenLookUpData = (
	state = {},
	screenId = '',
) => {
	const screenDetailsScreenIdData = get(
		state,
		`scripDetailsLookUpData.${screenId}`,
		{},
	);
	return screenDetailsScreenIdData;
};

// selectors
const initialState = {};

// reducer
export default createReducer(initialState, (builder) => {
	builder.addCase(setScripDetailsLookUpData, (state, action) => {
		const {
			scripSymbol = '',
			scripToken = '',
			scripSegment = '',
			screenId = '',
			foreignKey,
		} = action.payload;
		state[screenId] = {
			scripSymbol,
			scripToken,
			scripSegment,
			foreignKey: foreignKey,
		};
	});
});
